import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "app-container",
  class: "min-h-screen bg-background"
}
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = { class: "font-medium" }

import { useToast } from '@/composables/useToast';
import { useCartStore } from '@/stores/cartStore';
import { useAuthStore } from '@/stores/authStore';
import NavBar from '@/components/layout/header/NavBar.vue';
import SiteFooter from '@/components/layout/SiteFooter.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { toasts } = useToast();
const cartStore = useCartStore();
const authStore = useAuthStore();

// Hydrate cart from localStorage on app init
cartStore.hydrate();
authStore.hydrate();

const getToastClasses = (type: string): string => {
  switch (type) {
    case 'success':
      return 'bg-green-50 text-green-800 border border-green-200';
    case 'error':
      return 'bg-red-50 text-red-800 border border-red-200';
    case 'warning':
      return 'bg-yellow-50 text-yellow-800 border border-yellow-200';
    case 'info':
    default:
      return 'bg-blue-50 text-blue-800 border border-blue-200';
  }
};

const getToastIcon = (type: string): string => {
  switch (type) {
    case 'success':
      return 'fas fa-check-circle text-green-600';
    case 'error':
      return 'fas fa-exclamation-circle text-red-600';
    case 'warning':
      return 'fas fa-exclamation-triangle text-yellow-600';
    case 'info':
    default:
      return 'fas fa-info-circle text-blue-600';
  }
};

const onToastEnter = (el: Element) => {
  // Animation handled by CSS
};

const onToastLeave = (el: Element) => {
  // Animation handled by CSS
};

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavBar, { mode: 'hifi' }),
    _createVNode(_component_RouterView),
    _createVNode(_TransitionGroup, {
      tag: "div",
      name: "toast",
      class: "fixed top-[64px] right-4 z-50 space-y-2 pointer-events-none",
      onEnter: onToastEnter,
      onLeave: onToastLeave
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (toast) => {
          return (_openBlock(), _createElementBlock("div", {
            key: toast.id,
            class: _normalizeClass([
             'p-4 rounded-lg shadow-lg pointer-events-auto max-w-sm',
             getToastClasses(toast.type),
           ])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("i", {
                class: _normalizeClass(getToastIcon(toast.type))
              }, null, 2),
              _createElementVNode("span", _hoisted_3, _toDisplayString(toast.message), 1)
            ])
          ], 2))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(SiteFooter)
  ]))
}
}

})